
import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

interface EmailVerificationProps {
  setVerificationError: (error: string | null) => void;
  setVerificationDialogOpen: (open: boolean) => void;
}

const EmailVerification: React.FC<EmailVerificationProps> = ({
  setVerificationError,
  setVerificationDialogOpen,
}) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const error = searchParams.get("error");
    const error_description = searchParams.get("error_description");
    const token = searchParams.get("token");
    const type = searchParams.get("type");

    const handleEmailVerification = async () => {
      if (token && type === "signup") {
        try {
          setIsLoading(true);
          console.log("Starting email verification process with token:", token.substring(0, 5) + "...");
          
          // Log that we're calling the API
          console.log("Calling Supabase auth.verifyOtp API...");
          
          const { error } = await supabase.auth.verifyOtp({
            token_hash: token,
            type: "signup",
          });

          if (error) {
            console.error("Verification API returned an error:", error);
            throw error;
          }

          console.log("Email verification successful!");
          
          toast({
            title: "Email verified successfully!",
            description: "You can now sign in to access your account.",
          });
          
          navigate("/auth", { replace: true });
        } catch (error: any) {
          console.error("Verification error:", error);
          setVerificationError(error.message || "Email verification failed");
          setVerificationDialogOpen(true);
        } finally {
          setIsLoading(false);
        }
      } else if (error && error_description) {
        console.error(`Auth error: ${error}: ${error_description}`);
        setVerificationError(error_description);
        setVerificationDialogOpen(true);
      }
    };

    if (token || error) {
      console.log("Email verification parameters detected in URL. Processing...");
      handleEmailVerification();
    }
  }, [searchParams, navigate, setVerificationError, setVerificationDialogOpen]);

  return null; // This component doesn't render anything
};

export default EmailVerification;
